import { Container, ContainerProps } from '@mantine/core';
import styled from 'styled-components';

export const FormInputWrapper = styled.div`
	width: 100%;

	.mantine-MultiSelect-wrapper {
		.mantine-MultiSelect-input {
			display: flex;
			align-items: center;
			padding-top: 0.25rem;
			padding-bottom: 0.25rem;
		}

		.mantine-MultiSelect-values {
			min-height: 100%;
			max-width: 100%;
			row-gap: 0.5rem;
			column-gap: 0.25rem;
		}

		.mantine-MultiSelect-values:has(.mantine-Badge-root) {
			margin-left: 0rem;
		}

		.mantine-Input-rightSection {
			margin-top: 0.25rem;
		}

		.mantine-MultiSelect-value {
			margin: 0;
			padding: 0.25rem 0.25rem 0.25rem 0.5rem;
		}
	}
`;

export const EditValuationContainer = styled(Container)<ContainerProps>`
	margin: 0;
	overflow: auto;
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
`;
